export default [
    {
        path: "/hyc",
        name: "hyc__root__",
        redirect: {
            name: "hyc-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "hyc",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "hyc-index",
                component: () => import("@/views/hyc/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "admin",
                    affix: true,
                    group: 512,
                },
            },
        ],
    },
    {
        path: "/hyc/organizations",
        name: "hyc-organizations",
        meta: {
            title: "组织管理",
            icon: "organization",
            parent: "hyc",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        children: [
            {
                path: "",
                name: "hyc-organizations-index",
                component: () => import("@/views/hyc/organizations.vue"),
                meta: {
                    title: "组织管理",
                    icon: "organization",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/hyc/users",
        name: "hyc-users",
        meta: {
            title: "用户管理",
            icon: "users",
            parent: "hyc",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        children: [
            {
                path: "",
                name: "hyc-users-index",
                component: () => import("@/views/hyc/users.vue"),
                meta: {
                    title: "用户管理",
                    icon: "users",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/hyc/platform",
        name: "hyc-platform",
        meta: {
            title: "平台配置",
            icon: "all-setting",
            parent: "hyc",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/hyc/platform/permissions",
        children: [
            {
                path: "permissions",
                name: "hyc-platform-permissions",
                component: () => import("@/views/hyc/platform.vue"),
                meta: {
                    title: "权限管理",
                    icon: "all-setting",
                    affix: false,
                    platformTab: "permissions",
                },
            },
            {
                path: "configs",
                name: "hyc-platform-configs",
                component: () => import("@/views/hyc/platform.vue"),
                meta: {
                    title: "平台配置",
                    icon: "all-setting",
                    affix: false,
                    platformTab: "configs",
                },
            },
            {
                path: "display-configs",
                name: "hyc-platform-display-configs",
                component: () => import("@/views/hyc/platform.vue"),
                meta: {
                    title: "展示配置",
                    icon: "all-setting",
                    affix: false,
                    platformTab: "displayConfigs",
                },
            },
            {
                path: "crop-profiles",
                name: "hyc-platform-crop-profiles",
                component: () => import("@/views/hyc/platform.vue"),
                meta: {
                    title: "作物档案",
                    icon: "all-setting",
                    affix: false,
                    platformTab: "crops",
                },
            },
            {
                path: "preset-templates",
                name: "hyc-platform-preset-templates",
                component: () => import("@/views/hyc/platform.vue"),
                meta: {
                    title: "官方模板",
                    icon: "all-setting",
                    affix: false,
                    platformTab: "templates",
                },
            },
        ],
    },
    {
        path: "/hyc/billing",
        name: "hyc-billing",
        meta: {
            title: "计费管理",
            icon: "finance-bill",
            parent: "hyc",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/hyc/billing/operation-items",
        children: [
            {
                path: "operation-items",
                name: "hyc-billing-operation-items",
                component: () => import("@/views/hyc/billing.vue"),
                meta: {
                    title: "计费操作项",
                    icon: "bill",
                    affix: false,
                    billingTab: "operationItems",
                },
            },
            {
                path: "price-rules",
                name: "hyc-billing-price-rules",
                component: () => import("@/views/hyc/billing.vue"),
                meta: {
                    title: "价格规则",
                    icon: "price",
                    affix: false,
                    billingTab: "priceRules",
                },
            },
            {
                path: "discount-tiers",
                name: "hyc-billing-discount-tiers",
                component: () => import("@/views/hyc/billing.vue"),
                meta: {
                    title: "阶梯折扣",
                    icon: "discount",
                    affix: false,
                    billingTab: "discountTiers",
                },
            },
            {
                path: "accounts",
                name: "hyc-billing-accounts",
                component: () => import("@/views/hyc/billing.vue"),
                meta: {
                    title: "计费账户",
                    icon: "finance-bill",
                    affix: false,
                    billingTab: "accounts",
                },
            },
            {
                path: "usage-records",
                name: "hyc-billing-usage-records",
                component: () => import("@/views/hyc/billing.vue"),
                meta: {
                    title: "使用记录",
                    icon: "data",
                    affix: false,
                    billingTab: "usageRecords",
                },
            },
            {
                path: "sync-records",
                name: "hyc-billing-sync-records",
                component: () => import("@/views/hyc/billing.vue"),
                meta: {
                    title: "同步记录",
                    icon: "transfer",
                    affix: false,
                    billingTab: "syncRecords",
                },
            },
        ],
    },
    {
        path: "/hyc/dashboard",
        name: "hyc-dashboard",
        meta: {
            title: "数据查看",
            icon: "dashboard",
            parent: "hyc",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/hyc/dashboard/overview",
        children: [
            {
                path: "overview",
                name: "hyc-dashboard-overview",
                component: () => import("@/views/hyc/dashboard.vue"),
                meta: {
                    title: "总览",
                    icon: "dashboard",
                    affix: false,
                    dashboardType: "overview",
                },
            },
            {
                path: "weighing",
                name: "hyc-dashboard-weighing",
                component: () => import("@/views/hyc/dashboard.vue"),
                meta: {
                    title: "称重",
                    icon: "dashboard",
                    affix: false,
                    dashboardType: "weighing",
                },
            },
            {
                path: "inventory",
                name: "hyc-dashboard-inventory",
                component: () => import("@/views/hyc/dashboard.vue"),
                meta: {
                    title: "库存",
                    icon: "dashboard",
                    affix: false,
                    dashboardType: "inventory",
                },
            },
            {
                path: "salary",
                name: "hyc-dashboard-salary",
                component: () => import("@/views/hyc/dashboard.vue"),
                meta: {
                    title: "薪资",
                    icon: "dashboard",
                    affix: false,
                    dashboardType: "salary",
                },
            },
        ],
    },
];
